import React from 'react';
import { LoginInPro } from '../components/features/Login/LoginInPro';

export const LoginScreen = () => {
    return <LoginInPro />;
};
